/**
 * PDP interactive.
 * Handles: recommendations fetch, swatch/text-option selection.
 * Thumbnail gallery handler lives inline in sections/main-product.liquid (see data-pdp-gallery-fix).
 * Loaded with `defer` so it runs after parsing but doesn't block render.
 */
(function () {
  // ── Recommendations ──
  var recEl = document.querySelector('[data-product-recommendations]');
  if (recEl && recEl.dataset.url) {
    fetch(recEl.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rec = doc.querySelector('[data-product-recommendations]');
        if (rec && rec.innerHTML.trim()) recEl.innerHTML = rec.innerHTML;
      })
      .catch(function (err) { console.error(err); });
  }

  // ── Swatch + text-option click ──
  document.querySelectorAll('.pdp-buy__swatch, .pdp-buy__text-option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.dataset.optionValue;
      var group = btn.closest('[data-option-group]');
      if (group) {
        group.querySelectorAll('[data-option-value]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
      }
      var optionBlock = btn.closest('.pdp-buy__option');
      var label = optionBlock ? optionBlock.querySelector('[data-selected-option]') : null;
      if (label) label.textContent = value;
      var select = optionBlock ? optionBlock.querySelector('select[data-option-index]') : null;
      if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
